import Hero from "@/components/Hero";
import Feestbeleving from "@/components/Feestbeleving";
import CategoryCards from "@/components/CategoryCards";
import Timeline from "@/components/Timeline";
import AboutEric from "@/components/AboutEric";
import CTASection from "@/components/CTASection";
import ComboSection from "@/components/ComboSection";
import NewsletterSection from "@/components/NewsletterSection";
import SectionDivider from "@/components/SectionDivider";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const Home = () => {
  return (
    <>
      <Hero />
      <Feestbeleving />
      <CategoryCards />
      <SectionDivider />
      <Timeline />

      <ComboSection
        ids={["wedding-combo", "party-combo", "baby-journey", "memories-for-life"]}
        title="Meer beleving, meer voordeel"
      />

      <AboutEric />
      <SectionDivider />
      <NewsletterSection />
      <CTASection />

      {/* Discrete toegang tot de beheerpagina */}
      <div className="bg-ink py-8 text-center">
        <Link
          to="/admin"
          data-testid="home-admin-link"
          rel="nofollow"
          className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-white/25 hover:text-gold transition-colors"
        >
          <Lock size={11} strokeWidth={1.6} />
          Beheer
        </Link>
      </div>
    </>
  );
};

export default Home;
